import { render, staticRenderFns } from "./Tendencia.vue?vue&type=template&id=b68a7256&"
import script from "./Tendencia.vue?vue&type=script&lang=js&"
export * from "./Tendencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports